import React, { ReactNode } from "react";

import * as Styled from "./FilterButton.styles";

interface FilterButtonProps {
  title: string;
  isActive: boolean;
  onClick: () => void;
  icon?: ReactNode;
  ai?: boolean;
}

const FilterButton = ({ title, isActive, icon, onClick, ai }: FilterButtonProps) => {
  return (
    <Styled.Root
      text={title}
      position={"bottom"}
    >
      <Styled.FilterButton
        onClick={onClick}
        $isActive={isActive}
        $ai={ai}
      >
        {icon}
      </Styled.FilterButton>
    </Styled.Root>
  );
};

export { FilterButton };
